import React from 'react';
import './ChristmasDecorations.css';

const ChristmasDecorations = () => {
  return (
    <>
      {/* Top Left Corner - Elegant Pine Branch */}
      <div className="christmas-decoration top-left">
        <svg viewBox="0 0 180 120" className="decoration-svg" preserveAspectRatio="xMinYMin meet">
          <defs>
            {/* Gradient for pine needles - natural green tones */}
            <linearGradient id="pineGreen" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#2d5016" />
              <stop offset="100%" stopColor="#1a3d0f" />
            </linearGradient>

            {/* Gradient for berries - deep red */}
            <radialGradient id="berryRed">
              <stop offset="0%" stopColor="#d32f2f" />
              <stop offset="100%" stopColor="#8b1a1a" />
            </radialGradient>
          </defs>

          {/* Main branch */}
          <path
            d="M 10 20 Q 40 15, 80 25 Q 120 35, 160 30"
            stroke="#4a3728"
            strokeWidth="2.5"
            fill="none"
            opacity="0.7"
          />

          {/* Pine needle clusters - layered for depth */}
          <g className="pine-cluster" opacity="0.85">
            {/* Back layer */}
            <ellipse cx="25" cy="18" rx="14" ry="8" fill="url(#pineGreen)" opacity="0.6" transform="rotate(-15 25 18)" />
            <ellipse cx="55" cy="16" rx="16" ry="9" fill="url(#pineGreen)" opacity="0.6" transform="rotate(-10 55 16)" />
            <ellipse cx="90" cy="28" rx="15" ry="8" fill="url(#pineGreen)" opacity="0.6" transform="rotate(5 90 28)" />
            <ellipse cx="125" cy="35" rx="17" ry="9" fill="url(#pineGreen)" opacity="0.6" transform="rotate(10 125 35)" />
            <ellipse cx="150" cy="32" rx="14" ry="8" fill="url(#pineGreen)" opacity="0.6" transform="rotate(8 150 32)" />

            {/* Front layer - darker, more defined */}
            <ellipse cx="20" cy="22" rx="13" ry="7" fill="#2d5016" opacity="0.8" transform="rotate(-20 20 22)" />
            <ellipse cx="50" cy="20" rx="15" ry="8" fill="#2d5016" opacity="0.8" transform="rotate(-12 50 20)" />
            <ellipse cx="85" cy="32" rx="14" ry="7" fill="#2d5016" opacity="0.8" transform="rotate(8 85 32)" />
            <ellipse cx="120" cy="38" rx="16" ry="8" fill="#2d5016" opacity="0.8" transform="rotate(12 120 38)" />
            <ellipse cx="145" cy="35" rx="13" ry="7" fill="#2d5016" opacity="0.8" transform="rotate(10 145 35)" />
          </g>

          {/* Small berries - minimal and elegant */}
          <circle cx="45" cy="24" r="3.5" fill="url(#berryRed)" opacity="0.9" />
          <circle cx="48" cy="22" r="3" fill="url(#berryRed)" opacity="0.85" />
          <circle cx="110" cy="40" r="3.5" fill="url(#berryRed)" opacity="0.9" />
          <circle cx="113" cy="38" r="3" fill="url(#berryRed)" opacity="0.85" />

          {/* Subtle highlights on berries */}
          <circle cx="46" cy="23" r="1.2" fill="white" opacity="0.5" />
          <circle cx="111" cy="39" r="1.2" fill="white" opacity="0.5" />
        </svg>
      </div>

      {/* Top Right Corner - Mirrored */}
      <div className="christmas-decoration top-right">
        <svg viewBox="0 0 180 120" className="decoration-svg" preserveAspectRatio="xMaxYMin meet">
          <defs>
            <linearGradient id="pineGreen2" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#2d5016" />
              <stop offset="100%" stopColor="#1a3d0f" />
            </linearGradient>

            <radialGradient id="berryRed2">
              <stop offset="0%" stopColor="#d32f2f" />
              <stop offset="100%" stopColor="#8b1a1a" />
            </radialGradient>
          </defs>

          {/* Main branch (mirrored) */}
          <path
            d="M 170 20 Q 140 15, 100 25 Q 60 35, 20 30"
            stroke="#4a3728"
            strokeWidth="2.5"
            fill="none"
            opacity="0.7"
          />

          {/* Pine needle clusters */}
          <g className="pine-cluster" opacity="0.85">
            {/* Back layer */}
            <ellipse cx="155" cy="18" rx="14" ry="8" fill="url(#pineGreen2)" opacity="0.6" transform="rotate(15 155 18)" />
            <ellipse cx="125" cy="16" rx="16" ry="9" fill="url(#pineGreen2)" opacity="0.6" transform="rotate(10 125 16)" />
            <ellipse cx="90" cy="28" rx="15" ry="8" fill="url(#pineGreen2)" opacity="0.6" transform="rotate(-5 90 28)" />
            <ellipse cx="55" cy="35" rx="17" ry="9" fill="url(#pineGreen2)" opacity="0.6" transform="rotate(-10 55 35)" />
            <ellipse cx="30" cy="32" rx="14" ry="8" fill="url(#pineGreen2)" opacity="0.6" transform="rotate(-8 30 32)" />

            {/* Front layer */}
            <ellipse cx="160" cy="22" rx="13" ry="7" fill="#2d5016" opacity="0.8" transform="rotate(20 160 22)" />
            <ellipse cx="130" cy="20" rx="15" ry="8" fill="#2d5016" opacity="0.8" transform="rotate(12 130 20)" />
            <ellipse cx="95" cy="32" rx="14" ry="7" fill="#2d5016" opacity="0.8" transform="rotate(-8 95 32)" />
            <ellipse cx="60" cy="38" rx="16" ry="8" fill="#2d5016" opacity="0.8" transform="rotate(-12 60 38)" />
            <ellipse cx="35" cy="35" rx="13" ry="7" fill="#2d5016" opacity="0.8" transform="rotate(-10 35 35)" />
          </g>

          {/* Berries */}
          <circle cx="135" cy="24" r="3.5" fill="url(#berryRed2)" opacity="0.9" />
          <circle cx="132" cy="22" r="3" fill="url(#berryRed2)" opacity="0.85" />
          <circle cx="70" cy="40" r="3.5" fill="url(#berryRed2)" opacity="0.9" />
          <circle cx="67" cy="38" r="3" fill="url(#berryRed2)" opacity="0.85" />

          {/* Highlights */}
          <circle cx="134" cy="23" r="1.2" fill="white" opacity="0.5" />
          <circle cx="69" cy="39" r="1.2" fill="white" opacity="0.5" />
        </svg>
      </div>
    </>
  );
};

export default ChristmasDecorations;
